import React from "react";

import styled from "styled-components";
import { themeGet } from "styled-system";
import Box from "../Box";
import DefaultContainer from "./DefaultContainer";
import { FormattedMessage } from "react-intl";

import TextF1 from "../TextF1";
import TextF2 from "../TextF2";
import TextF3 from "../TextF3";
import TextF4 from "../TextF4";
import TextF6 from "../TextF6";
import TextF7 from "../TextF7";
import TextF8 from "../TextF8";

const terminologies = [
  { id: 1, title: "Slide 1 Title", content: "Slide 1 Text" },
  { id: 2, title: "Slide 2 Title", content: "Slide 2 Text" }
];

const StyledSubHeading = styled(TextF8)`
  color: #4844a3;
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  font-weight: normal;
`;

const SubHeading = StyledSubHeading.withComponent("h3");

const StyledHeading = styled(TextF6)`
  color: #4844a3;
  font-family: ${themeGet("fonts.TTNormsProBold")};
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

const RichText = styled(TextF7)`
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  line-height: 1.7;
  a {
    color: #9c329c;
    &:hover {
      text-decoration: none;
    }
  }
`;

const Heading = StyledHeading.withComponent("h2");

const StyledBox = styled(Box)`
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  margin-left: -1.5rem;
  margin-right: -1rem;
  margin-top: 6rem;
  margin-bottom: 6rem;
  @media screen and (min-width: 72em) {
    margin-left: -2.5rem;
    margin-right: -2rem;
  }
`;

export default class KeyTerminology extends React.Component {
  static defaultProps = {
    terminologies: terminologies
  };

  state = {
    terminologies: JSON.parse(this.props.terminologies)
  };

  render() {
    const content = this.state.terminologies.map((terminologies, index) => (
      <div key={index}>
        <Heading m={0}>{terminologies.title}</Heading>
        <RichText
          m={0}
          dangerouslySetInnerHTML={{ __html: terminologies.content }}
        />
      </div>
    ));

    return (
      <DefaultContainer>
        <StyledBox px={[3, 4]} pt={4} pb={5} borderLeft="8px solid #4844A3">
          <StyledSubHeading m={0}>
            <FormattedMessage id="section.block.keyTerminology" />
          </StyledSubHeading>
          {content}
        </StyledBox>
      </DefaultContainer>
    );
  }
}
